import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueAxios from 'vue-axios'

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import './assets/main.css'

import axios from "axios";
import store from '@/store'
import i18n from '@/translations'
import vuetify from '@/vuetify'
import * as Sentry from "@sentry/vue";
import { createGtag } from "vue-gtag";

const gtag = createGtag({
  tagId: import.meta.env.VITE_GOOGLE_ANALYTICS_TAG_ID,
  config: {
    send_page_view: false,
  },
})

const app = createApp(App)

app.use(VueAxios, axios)
app.use(router)
app.use(vuetify)
app.use(store)
app.use(i18n)
app.use(gtag)

// Only initialize Sentry on specific environments
const allowedHosts = [
  'staging.rhetorich.fi',
  'app.rhetorich.fi'
];

const currentHost = window.location.hostname;
const shouldInitSentry = allowedHosts.includes(currentHost);

if (shouldInitSentry) {
  Sentry.init({
    app,
    dsn: "https://f7ed45d4b8cf3deacdfdb6d928405068@o4509864583102464.ingest.de.sentry.io/4509864686518352",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router })
    ],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "staging.rhetorich.fi",
      "app.rhetorich.fi",
      /^https:\/\/staging\.rhetorich\.fi/,
      /^https:\/\/app\.rhetorich\.fi/
    ],
    // Set environment based on hostname
    environment: currentHost === 'app.rhetorich.fi' ? 'production' : 'staging',
    // Logs
    enableLogs: true
  });
}

app.mount('#app')
